import { useFormikContext } from 'formik';
import React from 'react';
import { useEffect } from 'react';

export const scrollToError = () => {
	const el = document.querySelector('.Mui-error, [data-error]');
	const element = el?.parentElement ?? el;

	if (!element) return;

	const headerOffset = 45;
	const rect = element.getBoundingClientRect();

	const viewportHeight = window.innerHeight ?? document.documentElement.clientHeight;

	const isVisible = rect.top >= headerOffset && rect.bottom <= viewportHeight;
	if (isVisible) return;

	const offsetPosition = rect.top + window.pageYOffset - headerOffset;
	try {
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});
	} catch (e) {
		console.error('Error scrolling to error element', e);
	}
};

export const FormikErrorScroll = ({ isSubmitting = false }) => {
	useEffect(() => {
		scrollToError();
	}, [isSubmitting]);
	return <></>;
};

export const useFormikHelper = (formik) => {
	const { errors, touched } = formik ?? useFormikContext();

	const getError = (title) => touched?.[title] && Boolean(errors?.[title]);
	const getErrorMessage = (title) => touched?.[title] && errors?.[title];

	return { getError, getErrorMessage };
};
